import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { displayValue, hasAnyValue } from "../../../../../../../utils/commonFunctions/displayValue";

export interface IMeasurementRow {
	label: string;
	left?: string | number | null;
	right?: string | number | null;
}

export interface MeasurementTableProps {
	title: string;
	unit?: string;
	rows: IMeasurementRow[];
}

const MeasurementTable = ({ title, unit, rows }: MeasurementTableProps) => {
	const visibleRows = rows.filter((row) => hasAnyValue([row.left, row.right]));

	if (visibleRows.length === 0) return null;

	return (
		<div className="measurement-table-block">
			<h4 className="measurement-table-title">
				{title}
				{unit ? <span className="measurement-table-unit"> ({unit})</span> : null}
			</h4>
			<TableContainer>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell />
							<TableCell align="center">Left</TableCell>
							<TableCell align="center">Right</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{visibleRows.map((row) => (
							<TableRow key={row.label}>
								<TableCell className="measurement-row-label">{row.label}</TableCell>
								<TableCell align="center">{displayValue(row.left)}</TableCell>
								<TableCell align="center">{displayValue(row.right)}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default MeasurementTable;
